import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AdminUser, Role } from '@/types';

interface UserState {
  user: AdminUser | null;
  permissions: string[];
  roles: Role[];
  isLogin: boolean;
  setUser: (user: AdminUser | null, permissions?: string[], roles?: Role[]) => void;
  clearUser: () => void;
  hasPermission: (...perms: string[]) => boolean;
  hasAnyPermission: (...perms: string[]) => boolean;
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      user: null,
      permissions: [],
      roles: [],
      isLogin: false,

      setUser: (user, permissions = [], roles = []) =>
        set({ user, permissions, roles, isLogin: !!user }),

      clearUser: () => set({ user: null, permissions: [], roles: [], isLogin: false }),

      hasPermission: (...perms) => {
        const { permissions } = get();
        return perms.every((p) => permissions.includes(p));
      },

      hasAnyPermission: (...perms) => {
        const { permissions } = get();
        return perms.some((p) => permissions.includes(p));
      }
    }),
    {
      name: 'admin-user-storage'
    }
  )
);
